import get from 'lodash.get';
import { finfoAInstance } from '../../../config/axios';
import { isWebMobile } from './utils';

type leadValues = {
  email: string;
  phoneNumber: string;
  leadType?: string;
  userName?: string;
  value?: string;
  productName?: string;
  whatsapp_consent?: 'true' | 'false';
  city?: string;
  note?: string;
};
export const getLeadPayload = (leadValues: leadValues) => {
  const {
    userName = leadValues.email,
    productName = 'Callback',
    whatsapp_consent = 'false',
    city = '',
    note = 'v2 FE',
  } = leadValues;
  return {
    leadPlatforms: {
      lsq: {
        ...(process.env.NEXT_PUBLIC_APP_ENV == 'production' && {
          add_lead: true,
        }),
      },
    },
    leadData: {
      type: 'marketplace-order-form',
      data: {
        leadType: leadValues.leadType?.toUpperCase() || 'CATEGORY',
        user_type_form: 'Marketplace',
        name: userName,
        user_device: isWebMobile(),
        phone_number: leadValues.phoneNumber,
        email: leadValues.email,
        value: leadValues.value ? leadValues.value : 0,
        product_selected: leadValues.productName,
        lead_source_page: get(document, ['title'], productName) || productName,
        lead_source_url: get(window, ['location', 'href'], ''),
        reference_url: get(document, ['refferer'], ''),
        note: leadValues.note ? leadValues.note : note,
        lead_creation_time: Math.floor(new Date().getTime() / 1000),
        city,
        whatsapp_consent,
      },
    },
  };
};

export const postLeadsToFinfo = (leadPayload: leadValues): Promise<string> => {
  return finfoAInstance
    .post(`common-lead/common-add-lead`, getLeadPayload(leadPayload))
    .then((data) => {
      return data;
    })
    .catch((error) => console.info('Lead failed :', error));
};
